/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable import/prefer-default-export */
/**
 * Function to return selected color range to indicate the room availability in rate calender based on the number
 * @param {*} _number - available room count
 * @returns
 */
export const selectColorRange = (_number) => {
  let color = '';
  switch (true) {
    case _number > 41:
      color = '#FF0000';
      break;
    case _number >= 21 && _number <= 40:
      color = '#F9EC2B';
      break;
    case _number >= 0 && _number <= 20:
    default:
      color = '#6AB98C';
      break;
  }
  return color;
};
